module.exports = __webpack_public_path__ + "img/21.4b45caeb.png";